/**
 * The human message inside an API error, whatever key it arrived under.
 *
 * The envelope is `{"error_messages": {...}}`, but the key is not fixed:
 * `AppException` uses `toast`, while `ValidationError` uses its own code —
 * `Invalid_Extension`, `File_Too_Large`, `Image_Too_Small`. Reading only
 * `toast` threw away every validation message the API sends, which is why
 * a rejected avatar showed "please try again" and nothing else.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const messages = (error as { error?: { error_messages?: unknown } })
    ?.error?.error_messages;

  if (typeof messages === 'string') return messages || fallback;
  if (!messages || typeof messages !== 'object') return fallback;

  const record = messages as Record<string, unknown>;
  if (typeof record['toast'] === 'string' && record['toast']) {
    return record['toast'];
  }
  const written = Object.values(record).filter(
    (v): v is string => typeof v === 'string' && !!v
  );
  return written.length ? written.join(', ') : fallback;
}
